import { logger } from '@/utils/logger/logger';

import { PLANNER_PAGINATION_LOG_TAG } from '../../constants/debug-tags';

/**
 * Debug logging for navigation/pagination decisions. Keeps the string assembly
 * out of the slice actions so their state logic stays readable.
 */
export const logPlannerNavigation = (action: string, payload: Record<string, unknown>): void => {
  const details = Object.entries(payload)
    .map(([key, value]) => `${key}=${value}`)
    .join(' ');
  logger.debug(PLANNER_PAGINATION_LOG_TAG, `${action}: ${details}`);
};
